<template>
  <footer class="footer">
    <div>
      <nav>
        <ul>
          <li v-for="link in navLinks" :key="link.title">
            <a :href="link.path" target="_blank">{{ link.title }}</a>
          </li>
        </ul>
      </nav>
      <a href="https://www.sekisui-hometechno.co.jp/" target="_blank">
        <img src="/images/logo.svg" alt="積水ホームテクノ株式会社">
      </a>
      <p class="copyright">
        <small>Copyright (C) SEKISUI HOMETECHNO CO., LTD.</small>
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
  data() {
    return {
      navLinks: [
        { path: "https://www.sekisui-hometechno.co.jp/utility/privacy/index.html", title: "個人情報保護方針" },
        { path: "https://www.sekisui-hometechno.co.jp/utility/guideline/index.html", title: "製品安全自主行動指針" },
        { path: "https://www.sekisui-hometechno.co.jp/utility/purpose/index.html", title: "お客様情報利用目的" },
        { path: "https://www.sekisui-hometechno.co.jp/utility/use-condition/index.html", title: "サイトご利用にあたって" }
      ]
    };
  }
};
</script>

<style scoped lang="scss">
.footer {
  position: relative;
  width: 100%;
  background: $colorFooter;
  padding: 36px 3vw;
  z-index: 5;
  @include mq(tb) {
    padding: 30px 15px;
  }
  > div {
    margin: 0 auto;
    
    @include mq(tb) {
      width: 100%;
    }
  }
}
nav {
  margin-bottom: 27px;
  @include mq(tb) {
    margin-bottom: 21px;
  }
}
ul {
  display: flex;
  flex-wrap: wrap;
  font-weight: bold;
  font-size: 13px;
  @include mq(tb) {
    font-size: 11px;
  }
  > li {
    position: relative;
    margin: 0 24px 0 18px;
    
    @include mq("tb") {
      margin-bottom: 6px;
    }
    &::before {
      position: absolute;
      top: 1px;
      left: -17px;
      color: #959394;
      font-size: 10px;
      content: "\f054";
      font-family: "Font Awesome 5 Free";
      font-weight: 900;
      @include mq("tb") {
        top: 3px;
      }
    }
  }
}
a {
  transition: $fastTransition;
  &:hover {
    opacity: $baseOpacity;
  }
}
img {
  margin-bottom: 6px;
  width: 188px;
}
.copyright {
  font-size: 11px;
}
</style>